import { CashCurveTypeBase } from './base/cash-curve-type-base';

export class CashCurveType extends CashCurveTypeBase { }